/**
 * User: WangMeng
 * Date: 2018-04-16
 * Time: 9:46
 * Desc: 新建账号
 */
import styles from './addAcount.scss';
import React, { Component } from 'react';
import { Modal, Form, Input, Select } from 'antd';
import { AccountType } from '../../../constants/enum';
import { AccountTypeText } from '../../../constants/info';
import LabelList from '../../common/labelList/LabelList';
import { debounce } from '../../../utils/debounce';
import { EmailCheck, tipsMoreN, UNameCheck, CNameCheck } from '../../../utils/validator';
import { getNameExist, getEmailExist } from '../../../services/user';
const FormItem = Form.Item;
const Option = Select.Option;
const LabelItem = LabelList.Item;

class AddAccount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            typeOptions: Object.values(AccountType).map(d => ({ label: AccountTypeText[d], value: d }))
        };
    }

    componentWillUnmount() {
        this.isEmailRepeat.cancel();
        this.isUNameRepeat.cancel();
    }

    onSubmit = (e) => {
        e.preventDefault();
        const { onConfirm } = this.props;
        this.props.form.validateFields({ force: true }, (err, values) => {
            if (!err) {
                onConfirm && onConfirm({ ...values });
            }
        });
    };

    isEmailRepeat = debounce((rule, value, callback) => {
        getEmailExist({ emailAdress: value }).then(data => {
            if (data.isExist) { // 已经存在
                callback('该邮箱已存在');
            } else {
                callback();
            }
        }).catch(() => {
            callback();
        });
    }, 500);

    isUNameRepeat = debounce((rule, value, callback) => {
        getNameExist({ userName: value }).then(data => {
            if (data.isExist) { // 已经存在
                callback('该账号已存在');
            } else {
                callback();
            }
        }).catch(() => {
            callback();
        });
    }, 500);

    getPopupContainer = () => {
        return document.querySelector('.add-account-modal');
    };

    render() {
        const { visible, onCancel } = this.props;
        const { getFieldDecorator } = this.props.form;
        const { typeOptions } = this.state;

        return (
            <Modal
                wrapClassName="add-account-modal"
                width={700}
                title="新建"
                visible={visible}
                footer={null}
                onCancel={onCancel}
                maskClosable={false}
            >
                <Form onSubmit={this.onSubmit}>
                    <LabelList className={styles.fromList}>
                        <LabelItem label="姓名">
                            <FormItem>
                                {getFieldDecorator('name', {
                                    validateFirst: true,
                                    rules: [{
                                        required: true, whitespace: true, message: '请输入姓名'
                                    }, {
                                        ...CNameCheck
                                    }]
                                })(
                                    <Input placeholder="2-10位中文、字母、数字或下划线" autoComplete="off"/>
                                )}
                            </FormItem>
                        </LabelItem>
                        <LabelItem label="部门">
                            <FormItem>
                                {getFieldDecorator('department', {
                                    validateFirst: true,
                                    rules: [{
                                        required: true, whitespace: true, message: '请输入部门'
                                    }, {
                                        max: 15, message: tipsMoreN(15)
                                    }]
                                })(
                                    <Input placeholder="15位以内" autoComplete="off"/>
                                )}
                            </FormItem>
                        </LabelItem>
                        <LabelItem label="账号">
                            <FormItem>
                                {getFieldDecorator('userName', {
                                    validateFirst: true,
                                    rules: [{
                                        required: true, whitespace: true, message: '请输入账号'
                                    }, {
                                        ...UNameCheck
                                    }, {
                                        validator: this.isUNameRepeat
                                    }]
                                })(
                                    <Input placeholder="2-16位字母、数字或下划线，以字母开头" autoComplete="off"/>
                                )}
                            </FormItem>
                        </LabelItem>
                        <LabelItem label="类型">
                            <FormItem>
                                {getFieldDecorator('type', {
                                    initialValue: AccountType.NORMAL.toString()
                                })(
                                    <Select size="default" getPopupContainer={this.getPopupContainer}>
                                        {typeOptions && typeOptions.map(d =>
                                            <Option key={d.value} value={d.value.toString()}>{d.label}</Option>
                                        )}
                                    </Select>
                                )}
                            </FormItem>
                        </LabelItem>
                        <LabelItem label="邮箱">
                            <FormItem>
                                {getFieldDecorator('emailAdress', {
                                    validateFirst: true,
                                    rules: [{
                                        required: true, whitespace: true, message: '请输入邮箱'
                                    }, {
                                        ...EmailCheck
                                    }, {
                                        max: 45, message: tipsMoreN(45)
                                    }, {
                                        validator: this.isEmailRepeat
                                    }]
                                })(
                                    <Input placeholder="45位以内" autoComplete="off"/>
                                )}
                            </FormItem>
                        </LabelItem>
                        <LabelItem>
                            <div className="btn-group">
                                <button type="submit" className="btn btn-blue">保存</button>
                            </div>
                        </LabelItem>
                    </LabelList>
                </Form>

            </Modal>
        );
    }
}

export default (Form.create({})(AddAccount));



// WEBPACK FOOTER //
// ./src/components/admin/index/AddAccount.jsx